import { useCallback } from 'react';
import * as screensizes from 'helpers/utils/screensizes';

export interface UseImageSizesParams {
  sm?: number;
  md?: number;
  lg?: number;
  defaultSize?: number;
  maxWidth?: number;
}

const useImageSizes = ({ sm, md, lg, defaultSize = 1, maxWidth = 1128 }: UseImageSizesParams) => {
  const stackImageSizes = useCallback((imageSizes: string, breakpoint: number, size: number) => {
    return `(max-width: ${breakpoint}px) ${size * 100}vw, ` + imageSizes;
  }, []);
  const applyMaxWidthCap = useCallback(
    (size: number) => {
      if (!size) return `${maxWidth}px`;

      const limitBreakpoint = Math.round(maxWidth / size);
      return `(max-width: ${limitBreakpoint}px) ${size * 100}vw, ${maxWidth}px`;
    },
    [maxWidth],
  );

  const calculateSizes = useCallback(() => {
    const finalSize = lg ?? defaultSize;

    let imageSizes = applyMaxWidthCap(finalSize);

    imageSizes = stackImageSizes(imageSizes, screensizes.tablet, md ?? finalSize);

    imageSizes = stackImageSizes(imageSizes, screensizes.mobile, sm ?? md ?? finalSize);

    return imageSizes;
  }, [sm, md, lg, defaultSize, stackImageSizes, applyMaxWidthCap]);

  return calculateSizes();
};

export default useImageSizes;
